import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import clsx from 'clsx';

@Component({
  selector: 'pxw-cart-view-shell',
  templateUrl: './cart-view-shell.component.html',
  styleUrls: ['./cart-view-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartViewShellComponent {
  readonly columns = input<number>(1);
  readonly readOnly = input(false);
  readonly stickyCategoryHeaders = input(false);

  @HostBinding('class')
  get hostClasses() {
    return clsx({
      'cart-view-shell--columns-2': this.columns() === 2,
      'cart-view-shell--readonly': this.readOnly(),
      'cart-view-shell--sticky-headers': this.stickyCategoryHeaders(),
    });
  }
}
